// extracted by mini-css-extract-plugin
module.exports = {"documentOptions":"styles_documentOptions__b8JNl","messageWrapper":"styles_messageWrapper__4pOEF"};